import React, { useState } from 'react'
import { Card, CardContent, CardHeader, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { HorizontalStackedBarChart } from '../../../charts/BarChart'
import { formatNumber } from '../../../../helpers/UtilityHelper'
import getColor from '../../../charts/colors'

const NPRRemarksAnalysis = ({ data }) => {
    const [view, setView] = useState('table')

    if (!data || !data.data || data.data.length === 0) return null

    const { attempts, data: tableData, grandTotals } = data

    const chartOptions = {
        yaxis: 'reason',
        data: attempts.map((attempt, i) => ({
            dataKey: attempt,
            label: `${attempt} Attempt`,
            fill: getColor(i),
        })),
        stackId: 'a',
        yLabel: 'Reason',
        showLabels: true,
        legendAlign: 'left',
    }

    return (
        <Card elevation={1}>
            <CardHeader
                title="NPR Remarks Analysis"
                subheader="Distribution of non-pickup remarks by attempt number"
                action={
                    <ToggleButtonGroup
                        value={view}
                        exclusive
                        size="small"
                        onChange={(_e, v) => v && setView(v)}
                    >
                        <ToggleButton value="chart">Chart</ToggleButton>
                        <ToggleButton value="table">Table</ToggleButton>
                    </ToggleButtonGroup>
                }
            />
            <CardContent>
                {view === 'chart' ? (
                    <HorizontalStackedBarChart data={tableData} chartOptions={chartOptions} height={Math.max(250, tableData.length * 35 + 80)} />
                ) : (
                    <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem', backgroundColor: '#FFF9C4' }}>Reason</TableCell>
                                    {attempts.map(attempt => (
                                        <TableCell key={attempt} align="center" sx={{ fontWeight: 'bold', fontSize: '0.75rem', backgroundColor: '#FFF9C4' }}>
                                            {attempt}
                                        </TableCell>
                                    ))}
                                    <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '0.75rem', backgroundColor: '#E0E0E0' }}>Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.map((row) => (
                                    <TableRow key={row.reason}>
                                        <TableCell sx={{ fontSize: '0.75rem' }}>{row.reason}</TableCell>
                                        {attempts.map(attempt => (
                                            <TableCell key={attempt} align="center" sx={{ fontSize: '0.75rem' }}>
                                                {formatNumber(row[attempt])}
                                            </TableCell>
                                        ))}
                                        <TableCell align="center" sx={{ fontSize: '0.75rem', fontWeight: 600 }}>
                                            {formatNumber(row.total)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow sx={{ backgroundColor: '#333' }}>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', fontSize: '0.75rem' }}>Grand Total</TableCell>
                                    {attempts.map(attempt => (
                                        <TableCell key={attempt} align="center" sx={{ color: '#fff', fontWeight: 'bold', fontSize: '0.75rem' }}>
                                            {formatNumber(grandTotals[attempt])}
                                        </TableCell>
                                    ))}
                                    <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold', fontSize: '0.75rem' }}>
                                        {formatNumber(grandTotals.total)}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </CardContent>
        </Card>
    )
}

export default NPRRemarksAnalysis
